import {getDqParamsObject} from 'module/CustomField/util/DqParam'
import CacheCollection from 'collection/CacheCollection'
import axios from 'axios'
import {log} from 'common/log'
import {CFValiTO} from 'generated/JavaTO'
import {FieldError} from 'module/CustomField/type/FieldError'
import {parseServerError} from 'module/Error/util/parseServerError'

let cfValiPromise: null | Promise<CFValiTO[]> = null;
const getCFValiPromise = () => {
	if (!cfValiPromise) {
		cfValiPromise = axios.get<CFValiTO[]>('../json/cfvali/all').then(resp => resp.data);
	}
	return cfValiPromise;
};

// force init after 8s
setTimeout(() => getCFValiPromise(), 8 * 1000);

const cache = new CacheCollection<Promise<undefined | FieldError>>();

export function validateRemoteCFVali(field: number, cfValiId: number, model: any, pos: number): Promise<undefined | FieldError> {
	return getCFValiPromise().then((cfValiList) => {
		const cfVali = cfValiList.find(x => x.id === cfValiId);
		if (!cfVali) {
			log.error(`Validation rule missing (id = ${cfValiId}, field = ${field})`);
			return {field, pos, message: "Validation rule not found"};
		}
		const {id, dqParams, cacheTTL} = cfVali;
		const clientParams = getDqParamsObject(dqParams, model, pos)
		const requestIdPath = [id, JSON.stringify(clientParams)]
		let data = cache.getCache(requestIdPath);
		if (!data) {
			data = axios.post<Promise<undefined | FieldError>>(`../json/cfvali/${encodeURIComponent(id)}`, clientParams)
				.then(() => undefined) //ok
				.catch((err) => {
					const message = parseServerError(err)
					const statusCode = err?.response?.status
					if (err?.message === 'Network Error' || statusCode !== 422 && Math.floor(statusCode / 100) !== 2) {
						cache.removeCache(requestIdPath, data || undefined)
						return {connectionError: true, message}
					}
					return ({message})
				}); //failed
			cache.setCache(requestIdPath, data, cacheTTL);
		}
		// set field and pos before return, so that pos is not in cache
		return data.then(x => x ? {...x, field, pos} : x)
	})
}